import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { brands } from '../data/brands';
import './Brands.css';

const Brands = () => {
  const { t } = useLanguage();
  const [backgroundErrors, setBackgroundErrors] = useState({});

  const handleBackgroundError = (brandId) => {
    setBackgroundErrors(prev => ({
      ...prev,
      [brandId]: true
    }));
  };

  return (
    <div className="brands-container">
      <h1 className="brands-title">{t('brands', 'Merken')}</h1>
      <div className="brands-grid">
        {brands.map((brand) => (
          <Link 
            key={brand.id} 
            to={`/brands/${brand.id}`}
            className="brand-card"
          >
            <div 
              className="brand-card-background"
              style={!backgroundErrors[brand.id] ? {
                backgroundImage: `url(${brand.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              } : {}}
            />
            <div className="brand-content">
              <h3 className="brand-name">{brand.name}</h3>
            </div>
            <img 
              src={brand.image}
              alt=""
              style={{ display: 'none' }}
              onError={() => handleBackgroundError(brand.id)}
            />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Brands; 